/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsExternalReferenceDetail {
    getFixupPrototypeFunction() { return AppSecopsExternalReferenceDetail.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsExternalReferenceDetail>): AppSecopsExternalReferenceDetail {
        let obj = Object.assign(new AppSecopsExternalReferenceDetail(), model);
        AppSecopsExternalReferenceDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsExternalReferenceDetail>): AppSecopsExternalReferenceDetail {
        if (!model) return null;
        return AppSecopsExternalReferenceDetail.newInstance(<AppSecopsExternalReferenceDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsExternalReferenceDetail) {
        if (!obj) return;

        models.AppSecopsExternalReferenceDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsExternalReferenceDetail): boolean {
        Object.setPrototypeOf(obj, AppSecopsExternalReferenceDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * External reference URL
     */
    url: string;

    /**
     * Name of the external reference
     */
    name: string;

    /**
     * Type of reference (e.g., advisory, report, fix)
     */
    type: string;

    /**
     * Source of the external reference
     */
    source: string;

}
